var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckAdvertisementActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3886 23H6.6117C5.54641 23 4.67969 22.1333 4.67969 21.068V4.93177C4.67969 3.86648 5.54641 2.99976 6.6117 2.99976H17.0225C17.1903 2.99976 17.3512 3.06643 17.4697 3.18491L21.1348 6.85038C21.2533 6.96886 21.3199 7.12974 21.3199 7.29751V21.068C21.3203 22.1336 20.4539 23 19.3886 23Z",
    fill: "url(#paint0_linear_4003_329)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1556 10.5807H8.15939C7.81009 10.5807 7.5271 10.2977 7.5271 9.94839C7.5271 9.59909 7.81045 9.3161 8.15939 9.3161H16.1556C16.5049 9.3161 16.7879 9.59945 16.7879 9.94839C16.7882 10.2977 16.5049 10.5807 16.1556 10.5807ZM13.0003 13.79H8.15939C7.81009 13.79 7.5271 13.507 7.5271 13.1577C7.5271 12.8084 7.81045 12.5254 8.15939 12.5254H13.0003C13.3496 12.5254 13.6326 12.8087 13.6326 13.1577C13.6326 13.5066 13.3496 13.79 13.0003 13.79ZM11.7158 16.6843H8.15939C7.81009 16.6843 7.5271 16.4014 7.5271 16.0521C7.5271 15.7028 7.81045 15.4198 8.15939 15.4198H11.7158C12.0651 15.4198 12.3481 15.7031 12.3481 16.0521C12.3484 16.401 12.0651 16.6843 11.7158 16.6843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1352 6.85038L17.4701 3.18528C17.3516 3.06679 17.1907 3.00012 17.0229 3.00012V3.63241V6.58804C17.0229 6.96597 17.3291 7.27215 17.7071 7.27215H21.32C21.3135 7.1138 21.2479 6.96307 21.1352 6.85038Z",
    fill: "url(#paint1_linear_4003_329)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4003_329",
    x1: -1.25861,
    y1: 0.192611,
    x2: 11.4026,
    y2: 12.8538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D77B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4003_329",
    x1: 17.0228,
    y1: 5.13606,
    x2: 21.3199,
    y2: 5.13606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#2F4E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAdvertisementActive);
export default __webpack_public_path__ + "static/media/checkAdvertisementActive.ade47f8f3671a8a2c7db06e9a829e168.svg";
export { ForwardRef as ReactComponent };